import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faCog,
  faUser,
  faMoneyBill,
  faCalendarAlt,
  faBook,
  faChartLine,
  faClipboardList,
  faSignOutAlt,
  faBell,
  faBars,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import '../../css/JuanIS/JuanISStudentDashboard.css';
import { useNavigate } from 'react-router-dom';
import SJDEFILogo from "../../images/SJDEFILogo.png";
import JuanISServices from './JuanISServices';
import JuanISStudentLedger from './JuanISStudentLedger';
import JuanISFlowchart from './JuanISFlowchart';
import JuanISClassSchedule from './JuanISClassSchedule';
import JuanISOnlineTeacherEvaluation from './JuanISOnlineTeacherEvaluation';
import JuanISProfile from './JuanISProfile';
import JuanISPayBills from './JuanISPayBills';

function JuanISStudentDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('home');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Mock user data for demonstration (replace with actual user data logic if needed)
  const email = 'juan.student@sjdefi.edu.ph';
  
  // Generate initials based on email
  const getEmailInitials = (email) => {
    const username = email.split('@')[0];
    return username.length >= 2 ? username.slice(0, 2).toUpperCase() : username.toUpperCase();
  };

  // Mask email for display
  const maskEmail = (email) => {
    const [username, domain] = email.split('@');
    if (username.length <= 4) {
      return `${username[0]}***@${domain}`;
    }
    return `${username.slice(0, 4)}****@${domain}`;
  };

  const handleLogout = () => {
    navigate('/juan-is-login');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleNotificationClick = () => {
    setActiveTab('services'); // Adjust to a relevant student tab
    setIsSidebarOpen(false);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'services':
        return <JuanISServices />;
      case 'ledger':
        return <JuanISStudentLedger />;
      case 'flowchart':
        return <JuanISFlowchart />;
      case 'schedule':
        return <JuanISClassSchedule />;
      case 'evaluation':
        return <JuanISOnlineTeacherEvaluation />;
      case 'profile':
        return <JuanISProfile />;
      case 'paybills':
        return <JuanISPayBills onBack={() => setActiveTab('home')} />;
      default:
        return (
          <>
            <div className="juanis-student-dashboard-welcome-banner">
              <h1>Welcome to JuanIS</h1>
              <div className="juanis-student-dashboard-welcome-icon">
                <FontAwesomeIcon icon={faUser} size="2x" />
              </div>
            </div>

            <div className="juanis-student-dashboard-content-section">
              <h2>Quick Access</h2>
              <div className="juanis-student-dashboard-quick-access-grid">
                <div className="juanis-student-dashboard-quick-access-card" onClick={() => setActiveTab('paybills')}>
                  <div className="juanis-student-dashboard-icon-container">
                    <FontAwesomeIcon icon={faMoneyBill} />
                  </div>
                  <span>Pay Bills</span>
                </div>
                <div className="juanis-student-dashboard-quick-access-card" onClick={() => setActiveTab('schedule')}>
                  <div className="juanis-student-dashboard-icon-container">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </div>
                  <span>Class Schedule</span>
                </div>
                <div className="juanis-student-dashboard-quick-access-card" onClick={() => setActiveTab('ledger')}>
                  <div className="juanis-student-dashboard-icon-container">
                    <FontAwesomeIcon icon={faBook} />
                  </div>
                  <span>Student Ledger</span>
                </div>
                <div className="juanis-student-dashboard-quick-access-card" onClick={() => setActiveTab('flowchart')}>
                  <div className="juanis-student-dashboard-icon-container">
                    <FontAwesomeIcon icon={faChartLine} />
                  </div>
                  <span>Flowchart</span>
                </div>
                <div className="juanis-student-dashboard-quick-access-card" onClick={() => setActiveTab('evaluation')}>
                  <div className="juanis-student-dashboard-icon-container">
                    <FontAwesomeIcon icon={faClipboardList} />
                  </div>
                  <span>Online Teacher's Evaluation (OTE)</span>
                </div>
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <div className="juanis-student-dashboard-container">
      {/* Header */}
      <header className="juanis-student-dashboard-header">
        <div className="juanis-student-dashboard-header-logo">
          <img src={SJDEFILogo} alt="SJDEFI Logo" />
          <span>JUAN IS</span>
        </div>
        <div className="juanis-student-dashboard-header-right">
          <div className="juanis-student-dashboard-notification-icon" onClick={handleNotificationClick}>
            <FontAwesomeIcon icon={faBell} />
          </div>
          <button className="juanis-student-dashboard-sidebar-toggle" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} />
          </button>
        </div>
      </header>

      <div className="juanis-student-dashboard-content">
        {/* Left Sidebar */}
        <div className={`juanis-student-dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <div className="juanis-student-dashboard-user-profile">
            <div className="juanis-student-dashboard-avatar">
              <div className="juanis-student-dashboard-avatar-initials">
                {getEmailInitials(email)}
              </div>
            </div>
            <div className="juanis-student-dashboard-user-info">
              <p className="juanis-student-dashboard-user-email">{maskEmail(email)}</p>
              <p className="juanis-student-dashboard-user-type">Student</p>
            </div>
          </div>

          <div className="juanis-student-dashboard-nav-section">
            <div className="juanis-student-dashboard-section-title">Main</div>
            <ul className="juanis-student-dashboard-nav-menu">
              <li className={activeTab === 'home' ? 'active' : ''} onClick={() => { setActiveTab('home'); setIsSidebarOpen(false); }}>
                <FontAwesomeIcon icon={faHome} style={activeTab === 'home' ? {color: '#FFB800'} : {}} />
                <span>Home</span>
              </li>
              <li className={activeTab === 'services' ? 'active' : ''} onClick={() => { setActiveTab('services'); setIsSidebarOpen(false); }}>
                <FontAwesomeIcon icon={faCog} style={activeTab === 'services' ? {color: '#FFB800'} : {}} />
                <span>Services</span>
              </li>
              <li className={activeTab === 'profile' ? 'active' : ''} onClick={() => { setActiveTab('profile'); setIsSidebarOpen(false); }}>
                <FontAwesomeIcon icon={faUser} style={activeTab === 'profile' ? {color: '#FFB800'} : {}} />
                <span>Profile</span>
              </li>
            </ul>
          </div>

          <div className="juanis-student-dashboard-nav-section">
            <div className="juanis-student-dashboard-section-title">Quick Access</div>
            <ul className="juanis-student-dashboard-nav-menu">
              <li className={activeTab === 'paybills' ? 'active' : ''} onClick={() => { setActiveTab('paybills'); setIsSidebarOpen(false); }}>
                <FontAwesomeIcon icon={faMoneyBill} style={activeTab === 'paybills' ? {color: '#FFB800'} : {}} />
                <span>Pay Bills</span>
              </li>
              <li className={activeTab === 'schedule' ? 'active' : ''} onClick={() => { setActiveTab('schedule'); setIsSidebarOpen(false); }}>
                <FontAwesomeIcon icon={faCalendarAlt} style={activeTab === 'schedule' ? {color: '#FFB800'} : {}} />
                <span>Class Schedule</span>
              </li>
              <li className={activeTab === 'ledger' ? 'active' : ''} onClick={() => { setActiveTab('ledger'); setIsSidebarOpen(false); }}>
                <FontAwesomeIcon icon={faBook} style={activeTab === 'ledger' ? {color: '#FFB800'} : {}} />
                <span>Student Ledger</span>
              </li>
              <li className={activeTab === 'flowchart' ? 'active' : ''} onClick={() => { setActiveTab('flowchart'); setIsSidebarOpen(false); }}>
                <FontAwesomeIcon icon={faChartLine} style={activeTab === 'flowchart' ? {color: '#FFB800'} : {}} />
                <span>Flowchart</span>
              </li>
              <li className={activeTab === 'evaluation' ? 'active' : ''} onClick={() => { setActiveTab('evaluation'); setIsSidebarOpen(false); }}>
                <FontAwesomeIcon icon={faClipboardList} style={activeTab === 'evaluation' ? {color: '#FFB800'} : {}} />
                <span>Online Teacher's Evaluation</span>
              </li>
            </ul>
          </div>

          <button className="juanis-student-dashboard-logout-button" onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
            <span>Logout</span>
          </button>
        </div>

        {/* Main Content */}
        <div className="juanis-student-dashboard-main-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default JuanISStudentDashboard;